import { CSSProperties } from 'react';

import imageStep1 from '../../images/png/questions/cim_noh_photo_800x500_etape_1.png';
import imageStep1Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_1.png';
import imageRoundStep1Hard from '../../images/png/questions/cim_noh_photo_rond_etape_1_difficile.png';
import imageStep2 from '../../images/png/questions/cim_noh_photo_800x500_etape_2.png';
import imageStep2Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_2.png';
import imageStep3 from '../../images/png/questions/cim_noh_photo_800x500_etape_3.png';
import imageStep3Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_3.png';
import imageRoundStep3_1 from '../../images/png/questions/cim_noh_photo_rond_etape_3-1.png';
import imageRoundStep3_2 from '../../images/png/questions/cim_noh_photo_rond_etape_3-2.png';
import imageStep4 from '../../images/png/questions/cim_noh_photo_800x500_etape_4.png';
import imageStep4Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_4.png';
import imageRoundStep4Hard from '../../images/png/questions/cim_noh_photo_rond_etape_4_difficile.png';
import imageStep5 from '../../images/png/questions/cim_noh_photo_800x500_etape_5.png';
import imageStep5Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_5.png';
import imageStep6 from '../../images/png/questions/cim_noh_photo_800x500_etape_6.png';
import imageStep6Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_6.png';
import imageStep7 from '../../images/png/questions/cim_noh_photo_800x500_etape_7.png';
import imageStep7Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_7.png';
import imageStep8 from '../../images/png/questions/cim_noh_photo_800x500_etape_8.png';
import imageStep8Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_8.png';
import imageStep9 from '../../images/png/questions/cim_noh_photo_800x500_etape_9.png';
import imageStep9Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_9.png';
import imageStep10 from '../../images/png/questions/cim_noh_photo_800x500_etape_10.png';
import imageStep10Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_10.png';
import imageStep11 from '../../images/png/questions/cim_noh_photo_800x500_etape_11.png';
import imageStep11Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_11.png';
import imageStep12 from '../../images/png/questions/cim_noh_photo_800x500_etape_12.png';
import imageStep12Intro from '../../images/png/questions/cim_noh_photo_intro_500x700_etape_12.png';

export type Animation = {
    name: string;
    composition: string;
    style: CSSProperties;
};

type QuestionsInfos = {
    count: number;
    goodMulti?: Array<number>;
    good?: number;
    roundImages?: Array<string>;
    helper?: boolean;
    multi?: boolean;
};

type Questions = {
    easy: QuestionsInfos;
    hard: QuestionsInfos;
};

export type Color = 'yellow' | 'lightgreen' | 'green' | 'darkgreen';

export type Config = {
    color: Color;
    subcolor: Color;
    animation?: Animation;
    questions: Questions;
    image: string;
    imageIntro: string;
};

type Configs = Array<Config>;

export const configs: Configs = [
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep1,
        imageIntro: imageStep1Intro,
        questions: {
            easy: {
                count: 3,
                good: 2,
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep2,
        imageIntro: imageStep2Intro,
        questions: {
            easy: {
                count: 3,
                good: 1,
            },
            hard: {
                count: 3,
                good: 2,
                roundImages: [imageRoundStep1Hard],
            },
        },
    },
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep3,
        imageIntro: imageStep3Intro,
        questions: {
            easy: {
                count: 3,
                good: 3,
                roundImages: [imageRoundStep3_1, imageRoundStep3_2],
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep4,
        imageIntro: imageStep4Intro,
        questions: {
            easy: {
                count: 2,
                good: 2,
            },
            hard: {
                roundImages: [imageRoundStep4Hard],
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep5,
        imageIntro: imageStep5Intro,
        questions: {
            easy: {
                count: 3,
                good: 1,
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep6,
        imageIntro: imageStep6Intro,
        questions: {
            easy: {
                count: 3,
                good: 2,
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep7,
        imageIntro: imageStep7Intro,
        questions: {
            easy: {
                count: 3,
                good: 3,
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep8,
        imageIntro: imageStep8Intro,
        questions: {
            easy: {
                count: 0,
                good: 1,
            },
            hard: {
                count: 0,
                good: 1,
            },
        },
    },
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep9,
        imageIntro: imageStep9Intro,
        questions: {
            easy: {
                count: 3,
                good: 3,
            },
            hard: {
                count: 3,
                good: 3,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep10,
        imageIntro: imageStep10Intro,
        questions: {
            easy: {
                count: 0,
                good: 1,
            },
            hard: {
                count: 0,
                good: 1,
            },
        },
    },
    {
        color: 'darkgreen',
        subcolor: 'yellow',
        image: imageStep11,
        imageIntro: imageStep11Intro,
        questions: {
            easy: {
                count: 3,
                good: 3,
            },
            hard: {
                count: 3,
                good: 1,
            },
        },
    },
    {
        color: 'yellow',
        subcolor: 'darkgreen',
        image: imageStep12,
        imageIntro: imageStep12Intro,
        questions: {
            easy: {
                count: 3,
                good: 1,
            },
            hard: {
                count: 3,
                good: 2,
            },
        },
    },
];

export const useGetConfig = (questionId?: string): Config | undefined =>
    questionId && questionId !== ''
        ? configs[parseInt(questionId, 10) - 1]
        : undefined;
